import React from 'react';
import { DifferentiatorsTimeline } from '../components/DifferentiatorsTimeline';
import { StrategicFeatures } from '../components/StrategicFeatures';
import { Grid } from '../components/ui/GridPattern';
import { MapPinIcon, ClockIcon, UsersIcon, DollarSignIcon, SearchIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
const StrategyPage = () => {
  return <div className="w-full min-h-screen bg-center bg-cover bg-no-repeat bg-gray-900" data-id="element-391">
      <div className="pt-28 sm:pt-32 md:pt-36" data-id="element-392">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-393">
          {/* Partnership Models Section */}
          <div className="mb-16 sm:mb-24" data-id="element-394">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal mb-6 sm:mb-8" data-id="element-395">
              Partnership Models
            </h2>
            <p className="text-base sm:text-lg text-gray-300 font-light text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-396">
              Most MSOs force a single path. ChiroVenture offers two — a clean
              buy-out or rolling into a growing platform with real upside.
              Either way, we take the back-office off your plate so you can
              focus on patients.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-10 sm:mb-14" data-id="element-397">
              {/* Card 1 — Full Buy-Out */}
              <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-398">
                <Grid size={20} data-id="element-399" />
                <div className="relative z-20" data-id="element-400">
                  <h3 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal text-center" data-id="element-401">
                    Full Buy-Out
                  </h3>
                  <div className="space-y-5" data-id="element-402">
                    <div data-id="element-403">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-404">
                        WHAT:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-405">
                        We acquire the clinic outright. You stay on as clinical
                        lead with compensation tied to performance.
                      </p>
                    </div>
                    <div data-id="element-406">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-407">
                        HOW:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-408">
                        ChiroVenture assumes management and infrastructure. You
                        focus on patient care and staff. We handle legal,
                        credentialing, billing, software, marketing, and
                        compliance.
                      </p>
                    </div>
                    <div data-id="element-409">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-410">
                        WHY:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-411">
                        Best for doctors ready to step out of ownership but stay
                        clinical, or looking for a defined exit on a 3-year
                        horizon.
                      </p>
                    </div>
                    <div data-id="element-412">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-413">
                        WHEN:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-414">
                        Close within 60–120 days.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Card 2 — Platform Partnership */}
              <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-415">
                <Grid size={20} data-id="element-416" />
                <div className="relative z-20" data-id="element-417">
                  <h3 className="text-2xl sm:text-3xl font-light text-white mb-4 sm:mb-6 tracking-normal text-center" data-id="element-418">
                    Platform Partnership
                  </h3>
                  <div className="space-y-5" data-id="element-419">
                    <div data-id="element-420">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-421">
                        WHAT:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-422">
                        You retain meaningful ownership in your clinic and roll
                        into the platform as a partner.
                      </p>
                    </div>
                    <div data-id="element-423">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-424">
                        HOW:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-425">
                        Your clinic plugs into our centralized systems, capital,
                        and playbook. You grow with us and participate in the
                        upside when the platform recapitalizes.
                      </p>
                    </div>
                    <div data-id="element-426">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-427">
                        WHY:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-428">
                        Best for growth-minded doctors who want infrastructure,
                        capital, and a bigger second bite — without giving up
                        control.
                      </p>
                    </div>
                    <div data-id="element-429">
                      <h4 className="text-[#4ECDC4] text-lg font-light mb-2" data-id="element-430">
                        WHEN:
                      </h4>
                      <p className="text-gray-300 font-light" data-id="element-431">
                        Close within 60–120 days. 3-year minimum commitment in
                        your current role.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Who We Partner With */}
            <div className="relative bg-gradient-to-b from-gray-900/50 to-gray-900/30 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm overflow-hidden" data-id="element-432">
              <Grid size={20} data-id="element-433" />
              <div className="relative z-20" data-id="element-434">
                <h3 className="text-xl sm:text-2xl font-light text-white mb-6 tracking-normal text-center" data-id="element-435">
                  Who We Partner With
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 max-w-3xl mx-auto" data-id="element-436">
                  {['Located in Texas or Florida', 'Growth-minded doctor, evangelist personality, strong team culture', 'Established revenue base with healthy margins', 'Strong cash collections', 'Financially transparent and coachable', '3-year minimum commitment post-close'].map((item, index) => <div key={index} className="flex items-start gap-3 bg-gray-900/30 p-3 sm:p-4 rounded-lg border border-gray-800/50" data-id="element-437">
                      <div className="flex-shrink-0 p-1.5 bg-[#4ECDC4]/20 rounded-full mt-0.5" data-id="element-438">
                        <CheckIcon className="w-4 h-4 text-[#4ECDC4]" data-id="element-439" />
                      </div>
                      <p className="text-gray-300 font-light text-sm sm:text-base" data-id="element-440">
                        {item}
                      </p>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
          {/* Strategy Section */}
          <div className="mb-16 sm:mb-24" data-id="element-441">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white text-center tracking-normal mb-8 sm:mb-12" data-id="element-442">
              Our Strategy
            </h2>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-443">
              <StrategicFeatures data-id="element-444" />
            </div>
          </div>
          {/* Differentiators Section */}
          <div className="mb-16 sm:mb-24" data-id="element-445">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-8 sm:mb-12 tracking-normal text-center" data-id="element-446">
              Our Differentiators
            </h1>
            <div className="bg-gray-900/50 p-4 sm:p-6 md:p-8 rounded-2xl border border-gray-700 shadow-sm" data-id="element-447">
              <div className="min-h-[600px] sm:min-h-[700px]" data-id="element-448">
                <DifferentiatorsTimeline data-id="element-449" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default StrategyPage;